var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.breadcrumbs.length
    ? _c(
        "ol",
        { staticClass: "breadcrumb" },
        _vm._l(_vm.breadcrumbs, function(crumb, i) {
          return crumb.meta.breadcrumb
            ? _c(
                "li",
                {
                  key: i,
                  staticClass: "breadcrumb-item",
                  attrs: { "data-trackname": "breadcrumb" }
                },
                [
                  i != _vm.breadcrumbs.length - 1 &&
                  _vm.breadcrumbs[i + 1].meta.breadcrumb != ""
                    ? _c(
                        "b-btn",
                        {
                          attrs: {
                            variant: "link",
                            "data-trackname": "breadcrumbLink"
                          },
                          on: {
                            click: function($event) {
                              _vm.route_push(crumb)
                            }
                          }
                        },
                        [_vm._v(_vm._s(crumb.meta.breadcrumb))]
                      )
                    : _c(
                        "b-btn",
                        { attrs: { variant: "link", disabled: "" } },
                        [_vm._v(_vm._s(crumb.meta.breadcrumb))]
                      )
                ],
                1
              )
            : _vm._e()
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/Breadcrumbs.vue?vue&type=template&id=5fd5c5fb&
// module id = null
// module chunks = 